import React from 'react'
import { Table } from 'camino-react'

import { columns } from './Columns'

import LoadingSpinner from 'Components/LoadingSpinner'

const ReportContent = ({ loading, tickets, localStoragePrefix }) => {
  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <Table
      columns={columns}
      data={tickets}
      pivotBy={['clientName']}
      localStoragePrefix={localStoragePrefix}
    />
  )
}

export default ReportContent
